const registerChecklistOwnerToggle = () => {
  $(function () {
    // disable dropdown if starter option is already checked
    var starter_inputs_checked = document.querySelectorAll('input.owner-choice[value="starter"]:checked');
    for(var i = 0 ; i < starter_inputs_checked.length; i++){
      starter_input = starter_inputs_checked[i];
      owner_input_name = starter_input.getAttribute('name').replace('owner_choice', 'owner');
      var owner_input = $('input[name="'+owner_input_name+'"]');
      owner_input.parent().addClass('disabled');
    };

    // disable dropdown if starter option has been checked
    $(document).on('click', 'input.owner-choice', function()  {
      owner_input_name = $(this).attr('name').replace('owner_choice', 'owner');
      var owner_input = $('input[name="'+owner_input_name+'"]');

      if (this.value == 'starter') {
        owner_input.parent().dropdown('clear');
        owner_input.parent().addClass('disabled');
      }
      else if (this.value == 'owner') {
        owner_input.parent().removeClass('disabled');
      }
    });
  });
};

const registerChecklistItemEdit = () => {
  registerChecklistOwnerToggle();
};

window.registerChecklistItemEdit = registerChecklistItemEdit;
